import $ from 'jquery';
import './legacy/jquery-1.11.3.min';
import './legacy/plugins';
// import './legacy/chart_global_options';
import './legacy/scripts';
window.$ = $;

document.body.classList.remove('no-js');
